import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  SimpleGrid,
  Tag,
  TagLabel,
  Text,
  useDisclosure,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import React, { useState } from "react";
import AddEditIdeaModal from "./AddEditIdeaModal";
import { useData } from "../../Contexts/DataContext";

const IdeaBoard = () => {
  const { ideas, selectedSow } = useData();
  const [modalData, setModalData] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [filterDeliverable, setFilterDeliverable] = useState("all");

  const openNewModal = () => {
    setModalData(null);
    onOpen();
  };

  const openEditModal = (idea) => {
    setModalData(idea);
    onOpen();
  };

  const filteredIdeas =
    filterDeliverable === "all"
      ? ideas
      : ideas.filter((idea) => idea.relatesTo === filterDeliverable);

  const uniqueDeliverables = Array.from(
    new Set(ideas.map((idea) => idea.relatesTo))
  ).filter(Boolean);

  return (
    <Box p={2} position="relative">
      <VStack w="100%" align="start" spacing={0}>
        <Flex justifyContent="flex-end" align="center" w="100%">
          <HStack>
            <Heading color="black" fontSize="xl">
              Idea Board
            </Heading>
          </HStack>
          <Button
            leftIcon={<AddIcon />}
            colorScheme="yellow"
            onClick={openNewModal}
            ml="auto"
            isDisabled={!selectedSow}
          >
            New Idea
          </Button>
        </Flex>

        <Text color="gray.500" fontSize="sm">
          Got an idea? Drop it here so you don’t forget it later.
        </Text>
      </VStack>

      {selectedSow && (
        <>
          <VStack align="start" px={4} my={8} w="100%" spacing={1}>
            <Text fontWeight="semibold" fontSize="sm" color="gray.600">
              Relates to:
            </Text>
            <Wrap spacing={2}>
              <WrapItem>
                <Tag
                  size="md"
                  variant={filterDeliverable === "all" ? "solid" : "subtle"}
                  colorScheme="blue"
                  cursor="pointer"
                  onClick={() => setFilterDeliverable("all")}
                >
                  <TagLabel>All</TagLabel>
                </Tag>
              </WrapItem>
              {uniqueDeliverables.map((relatesTo) => (
                <WrapItem key={relatesTo}>
                  <Tag
                    size="md"
                    variant={
                      filterDeliverable === relatesTo ? "solid" : "subtle"
                    }
                    colorScheme="blue"
                    cursor="pointer"
                    onClick={() => setFilterDeliverable(relatesTo)}
                  >
                    <TagLabel>{relatesTo}</TagLabel>
                  </Tag>
                </WrapItem>
              ))}
            </Wrap>
          </VStack>

          <AddEditIdeaModal
            isOpen={isOpen}
            onClose={onClose}
            data={modalData}
          />

          <SimpleGrid
            columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
            spacing={4}
            w="100%"
          >
            {filteredIdeas.map((idea) => (
              <Box
                key={idea.id}
                bg="yellow.100"
                px={6}
                py={4}
                borderRadius="md"
                boxShadow="md"
                minH="150px"
                transition="all 0.2s"
                cursor="pointer"
                onClick={() => openEditModal(idea)}
              >
                <VStack spacing={2}>
                  <Text fontSize="sm" fontWeight="bold" textAlign="center">
                    {idea.relatesTo}
                  </Text>
                  <Text fontSize="xs" textAlign="center" wordBreak="break-word">
                    {idea.note}
                  </Text>
                  <Text fontSize="xs" textAlign="center" color="gray.600">
                    Submitted by <strong>{idea.submittedBy}</strong> on{" "}
                    {new Date(idea.updatedAt).toLocaleString(undefined, {
                      dateStyle: "medium",
                      timeStyle: "short",
                    })}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </>
      )}
    </Box>
  );
};

export default IdeaBoard;
